import * as Types from '../../graphql/types.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExamsForFiltersFromPublicGroupUserNotLoggedInQueryVariables = Types.Exact<{
  input: Types.ExamsSelectionInput;
}>;


export type ExamsForFiltersFromPublicGroupUserNotLoggedInQuery = { __typename?: 'Query', publicGroups: Array<{ __typename?: 'GroupView', possibleExamTags: Array<string>, exams: { __typename?: 'ExamViewPaginationResultSetView', total: number, items: Array<{ __typename?: 'ExamView', id: string, tags: Array<string> }> } }> };

export type ExamsForFiltersFromGroupQueryVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  input: Types.ExamsSelectionInput;
}>;


export type ExamsForFiltersFromGroupQuery = { __typename?: 'Query', group?: { __typename?: 'GroupView', code: string, possibleExamTags: Array<string>, exams: { __typename?: 'ExamViewPaginationResultSetView', total: number, items: Array<{ __typename?: 'ExamView', myHighestResult?: Types.HighestExamResultView | null, id: string, tags: Array<string> }> } } | null };

export type ExamsFromGroupQueryVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  input: Types.ExamsSelectionInput;
}>;


export type ExamsFromGroupQuery = { __typename?: 'Query', group?: { __typename?: 'GroupView', code: string, possibleExamTags: Array<string>, exams: { __typename?: 'ExamViewPaginationResultSetView', total: number, items: Array<{ __typename?: 'ExamView', myHighestResult?: Types.HighestExamResultView | null, revisionId: string, difficultyLevel: Types.ExamDifficultyLevelView, id: string, name: string, tags: Array<string>, updatedAt: any, vulnerability: Types.ExamVulnerabilityView, comment?: string | null, definition: { __typename?: 'ExamDefinitionView', answers: Array<{ __typename?: 'ExamAnswerView', biddingSequence: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }>, halfAnswers: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }>, matchingAnswers: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }> }>, cards: Array<{ __typename?: 'CardView', color: Types.CardColorView, value: Types.CardValueView }>, initialBiddingSequence: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }> } }>, options: { __typename?: 'PaginationOptionsView', limit: number, offset: number } } } | null };

export type ExamFromGroupQueryVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  input: Types.ExamSelectionInput;
}>;


export type ExamFromGroupQuery = { __typename?: 'Query', group?: { __typename?: 'GroupView', exam?: { __typename?: 'ExamView', comment?: string | null, difficultyLevel: Types.ExamDifficultyLevelView, id: string, tags: Array<string>, name: string, updatedAt: any, vulnerability: Types.ExamVulnerabilityView, revisionId: string, definition: { __typename?: 'ExamDefinitionView', answers: Array<{ __typename?: 'ExamAnswerView', biddingSequence: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }>, halfAnswers: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }>, matchingAnswers: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }> }>, cards: Array<{ __typename?: 'CardView', color: Types.CardColorView, value: Types.CardValueView }>, initialBiddingSequence: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }> } } | null } | null };

export type PublicGroupsQueryVariables = Types.Exact<{
  input: Types.ExamSelectionInput;
}>;


export type PublicGroupsQuery = { __typename?: 'Query', publicGroups: Array<{ __typename?: 'GroupView', exam?: { __typename?: 'ExamView', difficultyLevel: Types.ExamDifficultyLevelView, id: string, name: string, tags: Array<string>, comment?: string | null, updatedAt: any, vulnerability: Types.ExamVulnerabilityView, revisionId: string, definition: { __typename?: 'ExamDefinitionView', answers: Array<{ __typename?: 'ExamAnswerView', biddingSequence: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }>, halfAnswers: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }>, matchingAnswers: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }> }>, cards: Array<{ __typename?: 'CardView', color: Types.CardColorView, value: Types.CardValueView }>, initialBiddingSequence: Array<{ __typename?: 'BiddingView', declaration: Types.BiddingDeclarationView, shouldAlert: boolean, bidCard?: { __typename?: 'BiddingCardView', color: Types.BiddingCardColorView, value: Types.BiddingCardValueView } | null }> } } | null }> };

export type ExamResultsSaveMutationVariables = Types.Exact<{
  input: Types.SaveExamResultsInput;
}>;


export type ExamResultsSaveMutation = { __typename?: 'Mutation', examResultsSave: { __typename?: 'SaveExamResultsFailureView', reason: string } | { __typename?: 'SaveExamResultsSuccessView', examResultId: string } };


export const ExamsForFiltersFromPublicGroupUserNotLoggedInDocument = gql`
    query ExamsForFiltersFromPublicGroupUserNotLoggedIn($input: ExamsSelectionInput!) {
  publicGroups {
    possibleExamTags
    exams(input: $input) {
      items {
        id
        tags
      }
      total
    }
  }
}
    `;

/**
 * __useExamsForFiltersFromPublicGroupUserNotLoggedInQuery__
 *
 * To run a query within a React component, call `useExamsForFiltersFromPublicGroupUserNotLoggedInQuery` and pass it any options that fit your needs.
 * When your component renders, `useExamsForFiltersFromPublicGroupUserNotLoggedInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExamsForFiltersFromPublicGroupUserNotLoggedInQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExamsForFiltersFromPublicGroupUserNotLoggedInQuery(baseOptions: Apollo.QueryHookOptions<ExamsForFiltersFromPublicGroupUserNotLoggedInQuery, ExamsForFiltersFromPublicGroupUserNotLoggedInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExamsForFiltersFromPublicGroupUserNotLoggedInQuery, ExamsForFiltersFromPublicGroupUserNotLoggedInQueryVariables>(ExamsForFiltersFromPublicGroupUserNotLoggedInDocument, options);
      }
export function useExamsForFiltersFromPublicGroupUserNotLoggedInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExamsForFiltersFromPublicGroupUserNotLoggedInQuery, ExamsForFiltersFromPublicGroupUserNotLoggedInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExamsForFiltersFromPublicGroupUserNotLoggedInQuery, ExamsForFiltersFromPublicGroupUserNotLoggedInQueryVariables>(ExamsForFiltersFromPublicGroupUserNotLoggedInDocument, options);
        }
export function useExamsForFiltersFromPublicGroupUserNotLoggedInSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExamsForFiltersFromPublicGroupUserNotLoggedInQuery, ExamsForFiltersFromPublicGroupUserNotLoggedInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExamsForFiltersFromPublicGroupUserNotLoggedInQuery, ExamsForFiltersFromPublicGroupUserNotLoggedInQueryVariables>(ExamsForFiltersFromPublicGroupUserNotLoggedInDocument, options);
        }
export type ExamsForFiltersFromPublicGroupUserNotLoggedInQueryHookResult = ReturnType<typeof useExamsForFiltersFromPublicGroupUserNotLoggedInQuery>;
export type ExamsForFiltersFromPublicGroupUserNotLoggedInLazyQueryHookResult = ReturnType<typeof useExamsForFiltersFromPublicGroupUserNotLoggedInLazyQuery>;
export type ExamsForFiltersFromPublicGroupUserNotLoggedInSuspenseQueryHookResult = ReturnType<typeof useExamsForFiltersFromPublicGroupUserNotLoggedInSuspenseQuery>;
export type ExamsForFiltersFromPublicGroupUserNotLoggedInQueryResult = Apollo.QueryResult<ExamsForFiltersFromPublicGroupUserNotLoggedInQuery, ExamsForFiltersFromPublicGroupUserNotLoggedInQueryVariables>;
export const ExamsForFiltersFromGroupDocument = gql`
    query ExamsForFiltersFromGroup($code: String!, $input: ExamsSelectionInput!) {
  group(code: $code) {
    code
    possibleExamTags
    exams(input: $input) {
      items {
        myHighestResult
        id
        tags
      }
      total
    }
  }
}
    `;

/**
 * __useExamsForFiltersFromGroupQuery__
 *
 * To run a query within a React component, call `useExamsForFiltersFromGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useExamsForFiltersFromGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExamsForFiltersFromGroupQuery({
 *   variables: {
 *      code: // value for 'code'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExamsForFiltersFromGroupQuery(baseOptions: Apollo.QueryHookOptions<ExamsForFiltersFromGroupQuery, ExamsForFiltersFromGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExamsForFiltersFromGroupQuery, ExamsForFiltersFromGroupQueryVariables>(ExamsForFiltersFromGroupDocument, options);
      }
export function useExamsForFiltersFromGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExamsForFiltersFromGroupQuery, ExamsForFiltersFromGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExamsForFiltersFromGroupQuery, ExamsForFiltersFromGroupQueryVariables>(ExamsForFiltersFromGroupDocument, options);
        }
export function useExamsForFiltersFromGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExamsForFiltersFromGroupQuery, ExamsForFiltersFromGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExamsForFiltersFromGroupQuery, ExamsForFiltersFromGroupQueryVariables>(ExamsForFiltersFromGroupDocument, options);
        }
export type ExamsForFiltersFromGroupQueryHookResult = ReturnType<typeof useExamsForFiltersFromGroupQuery>;
export type ExamsForFiltersFromGroupLazyQueryHookResult = ReturnType<typeof useExamsForFiltersFromGroupLazyQuery>;
export type ExamsForFiltersFromGroupSuspenseQueryHookResult = ReturnType<typeof useExamsForFiltersFromGroupSuspenseQuery>;
export type ExamsForFiltersFromGroupQueryResult = Apollo.QueryResult<ExamsForFiltersFromGroupQuery, ExamsForFiltersFromGroupQueryVariables>;
export const ExamsFromGroupDocument = gql`
    query ExamsFromGroup($code: String!, $input: ExamsSelectionInput!) {
  group(code: $code) {
    code
    possibleExamTags
    exams(input: $input) {
      items {
        myHighestResult
        definition {
          answers {
            biddingSequence {
              bidCard {
                color
                value
              }
              declaration
              shouldAlert
            }
            halfAnswers {
              bidCard {
                color
                value
              }
              declaration
              shouldAlert
            }
            matchingAnswers {
              bidCard {
                color
                value
              }
              declaration
              shouldAlert
            }
          }
          cards {
            color
            value
          }
          initialBiddingSequence {
            bidCard {
              color
              value
            }
            declaration
            shouldAlert
          }
        }
        revisionId
        difficultyLevel
        id
        name
        tags
        updatedAt
        vulnerability
        comment
      }
      options {
        limit
        offset
      }
      total
    }
  }
}
    `;

/**
 * __useExamsFromGroupQuery__
 *
 * To run a query within a React component, call `useExamsFromGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useExamsFromGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExamsFromGroupQuery({
 *   variables: {
 *      code: // value for 'code'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExamsFromGroupQuery(baseOptions: Apollo.QueryHookOptions<ExamsFromGroupQuery, ExamsFromGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExamsFromGroupQuery, ExamsFromGroupQueryVariables>(ExamsFromGroupDocument, options);
      }
export function useExamsFromGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExamsFromGroupQuery, ExamsFromGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExamsFromGroupQuery, ExamsFromGroupQueryVariables>(ExamsFromGroupDocument, options);
        }
export function useExamsFromGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExamsFromGroupQuery, ExamsFromGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExamsFromGroupQuery, ExamsFromGroupQueryVariables>(ExamsFromGroupDocument, options);
        }
export type ExamsFromGroupQueryHookResult = ReturnType<typeof useExamsFromGroupQuery>;
export type ExamsFromGroupLazyQueryHookResult = ReturnType<typeof useExamsFromGroupLazyQuery>;
export type ExamsFromGroupSuspenseQueryHookResult = ReturnType<typeof useExamsFromGroupSuspenseQuery>;
export type ExamsFromGroupQueryResult = Apollo.QueryResult<ExamsFromGroupQuery, ExamsFromGroupQueryVariables>;
export const ExamFromGroupDocument = gql`
    query ExamFromGroup($code: String!, $input: ExamSelectionInput!) {
  group(code: $code) {
    exam(input: $input) {
      definition {
        answers {
          biddingSequence {
            bidCard {
              color
              value
            }
            declaration
            shouldAlert
          }
          halfAnswers {
            bidCard {
              color
              value
            }
            declaration
            shouldAlert
          }
          matchingAnswers {
            bidCard {
              color
              value
            }
            declaration
            shouldAlert
          }
        }
        cards {
          color
          value
        }
        initialBiddingSequence {
          bidCard {
            color
            value
          }
          declaration
          shouldAlert
        }
      }
      comment
      difficultyLevel
      id
      tags
      name
      updatedAt
      vulnerability
      revisionId
    }
  }
}
    `;

/**
 * __useExamFromGroupQuery__
 *
 * To run a query within a React component, call `useExamFromGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useExamFromGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExamFromGroupQuery({
 *   variables: {
 *      code: // value for 'code'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExamFromGroupQuery(baseOptions: Apollo.QueryHookOptions<ExamFromGroupQuery, ExamFromGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExamFromGroupQuery, ExamFromGroupQueryVariables>(ExamFromGroupDocument, options);
      }
export function useExamFromGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExamFromGroupQuery, ExamFromGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExamFromGroupQuery, ExamFromGroupQueryVariables>(ExamFromGroupDocument, options);
        }
export function useExamFromGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExamFromGroupQuery, ExamFromGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExamFromGroupQuery, ExamFromGroupQueryVariables>(ExamFromGroupDocument, options);
        }
export type ExamFromGroupQueryHookResult = ReturnType<typeof useExamFromGroupQuery>;
export type ExamFromGroupLazyQueryHookResult = ReturnType<typeof useExamFromGroupLazyQuery>;
export type ExamFromGroupSuspenseQueryHookResult = ReturnType<typeof useExamFromGroupSuspenseQuery>;
export type ExamFromGroupQueryResult = Apollo.QueryResult<ExamFromGroupQuery, ExamFromGroupQueryVariables>;
export const PublicGroupsDocument = gql`
    query PublicGroups($input: ExamSelectionInput!) {
  publicGroups {
    exam(input: $input) {
      definition {
        answers {
          biddingSequence {
            bidCard {
              color
              value
            }
            declaration
            shouldAlert
          }
          halfAnswers {
            bidCard {
              color
              value
            }
            declaration
            shouldAlert
          }
          matchingAnswers {
            bidCard {
              color
              value
            }
            declaration
            shouldAlert
          }
        }
        cards {
          color
          value
        }
        initialBiddingSequence {
          bidCard {
            color
            value
          }
          declaration
          shouldAlert
        }
      }
      difficultyLevel
      id
      name
      tags
      comment
      updatedAt
      vulnerability
      revisionId
    }
  }
}
    `;

/**
 * __usePublicGroupsQuery__
 *
 * To run a query within a React component, call `usePublicGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicGroupsQuery(baseOptions: Apollo.QueryHookOptions<PublicGroupsQuery, PublicGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicGroupsQuery, PublicGroupsQueryVariables>(PublicGroupsDocument, options);
      }
export function usePublicGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicGroupsQuery, PublicGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicGroupsQuery, PublicGroupsQueryVariables>(PublicGroupsDocument, options);
        }
export function usePublicGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicGroupsQuery, PublicGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicGroupsQuery, PublicGroupsQueryVariables>(PublicGroupsDocument, options);
        }
export type PublicGroupsQueryHookResult = ReturnType<typeof usePublicGroupsQuery>;
export type PublicGroupsLazyQueryHookResult = ReturnType<typeof usePublicGroupsLazyQuery>;
export type PublicGroupsSuspenseQueryHookResult = ReturnType<typeof usePublicGroupsSuspenseQuery>;
export type PublicGroupsQueryResult = Apollo.QueryResult<PublicGroupsQuery, PublicGroupsQueryVariables>;
export const ExamResultsSaveDocument = gql`
    mutation ExamResultsSave($input: SaveExamResultsInput!) {
  examResultsSave(input: $input) {
    ... on SaveExamResultsFailureView {
      reason
    }
    ... on SaveExamResultsSuccessView {
      examResultId
    }
  }
}
    `;
export type ExamResultsSaveMutationFn = Apollo.MutationFunction<ExamResultsSaveMutation, ExamResultsSaveMutationVariables>;

/**
 * __useExamResultsSaveMutation__
 *
 * To run a mutation, you first call `useExamResultsSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExamResultsSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [examResultsSaveMutation, { data, loading, error }] = useExamResultsSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExamResultsSaveMutation(baseOptions?: Apollo.MutationHookOptions<ExamResultsSaveMutation, ExamResultsSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExamResultsSaveMutation, ExamResultsSaveMutationVariables>(ExamResultsSaveDocument, options);
      }
export type ExamResultsSaveMutationHookResult = ReturnType<typeof useExamResultsSaveMutation>;
export type ExamResultsSaveMutationResult = Apollo.MutationResult<ExamResultsSaveMutation>;
export type ExamResultsSaveMutationOptions = Apollo.BaseMutationOptions<ExamResultsSaveMutation, ExamResultsSaveMutationVariables>;